import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useAppDispatch } from "../../../../hooks/useTypedSelector";
import {
  fetchEventsCount,
  updateEventStatus,
} from "../../infrastructure/eventMutateSlice";
import { EventStatus } from "../../domain/models/EventModel";
import { CheckLg, Gear, XLg } from "react-bootstrap-icons";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ColumnDef } from "@tanstack/react-table";

export const EventStatusColumn = ({
  id,
  status,
  column,
}: {
  id: number;
  status: EventStatus;
  column: ColumnDef<{
    [x: string]: unknown;
  }>;
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation("common");

  const availableTransitions = useMemo(() => {
    switch (status) {
      case EventStatus.NEW:
        return [
          EventStatus.IN_PROCESS,
          EventStatus.COMPLETED,
          EventStatus.REJECTED,
        ];
      case EventStatus.IN_PROCESS:
        return [EventStatus.COMPLETED, EventStatus.REJECTED];
      case EventStatus.COMPLETED:
        return [];
      case EventStatus.REJECTED:
        return [];
    }
  }, [status]);

  const getButtonVariant = (transition: EventStatus) => {
    switch (transition) {
      case EventStatus.COMPLETED:
        return "success";
      case EventStatus.IN_PROCESS:
        return "warning";
      case EventStatus.REJECTED:
        return "danger";
    }
  };

  const getButtonIcon = (transition: EventStatus) => {
    switch (transition) {
      case EventStatus.COMPLETED:
        return <CheckLg size={16} />;
      case EventStatus.IN_PROCESS:
        return <Gear size={16} color="white" />;
      case EventStatus.REJECTED:
        return <XLg size={16} />;
    }
  };

  const getButtonTooltipText = (transition: EventStatus) => {
    switch (transition) {
      case EventStatus.COMPLETED:
        return t("Complete");
      case EventStatus.IN_PROCESS:
        return t("In process");
      case EventStatus.REJECTED:
        return t("Reject");
    }
  };

  return (
    <div className="d-flex gap-1">
      {availableTransitions?.map((transition) => (
        <OverlayTrigger
          key={transition}
          overlay={
            <Tooltip className="custom-tooltip">
              {getButtonTooltipText(transition)}
            </Tooltip>
          }
        >
          <Button
            onClick={() => {
              void dispatch(
                updateEventStatus({
                  id: id,
                  status: transition,
                }),
              ).finally(() => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                if (column?.columnDef?.meta?.triggerUpdate != null) {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                  column?.columnDef?.meta?.triggerUpdate();
                }
                void dispatch(fetchEventsCount());
              });
            }}
            size="sm"
            variant={getButtonVariant(transition)}
          >
            {getButtonIcon(transition)}
          </Button>
        </OverlayTrigger>
      ))}
    </div>
  );
};
